import { createSlice } from "@reduxjs/toolkit";

import {
	fetchTransactions,
	fetchAllTransactions,
	createTransaction,
	changeTransaction,
	deleteTransaction,
} from "./transactionThunk";

const initialState = {
	transactions: [],
	isLoading: false,
	isError: false,
	error: "",
	editing: {},
	deleting: {},
};

// Create slice
const transactionSlice = createSlice({
	name: "transaction",
	initialState,
	reducers: {
		editActive: (state, action) => {
			state.editing = action.payload;
		},
		editInactive: (state) => {
			state.editing = {};
		},
		deleteActive: (state, action) => {
			state.deleting = action.payload;
		},
		deleteInactive: (state) => {
			state.deleting = {};
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchTransactions.pending, (state) => {
				state.isError = false;
				state.isLoading = true;
				state.pages = 0;
			})
			.addCase(fetchTransactions.fulfilled, (state, action) => {
				state.isError = false;
				state.isLoading = false;
				state.transactions = action.payload.transactions;
				state.pages = action.payload.pages;
			})
			.addCase(fetchTransactions.rejected, (state, action) => {
				state.isError = true;
				state.isLoading = false;
				state.transactions = [];
				state.error = action.error?.message;
				state.pages = 0;
			})
			.addCase(fetchAllTransactions.pending, (state) => {
				state.isError = false;
				state.isLoading = true;
				state.pages = 0;
			})
			.addCase(fetchAllTransactions.fulfilled, (state, action) => {
				state.isError = false;
				state.isLoading = false;
				state.transactions = action.payload;
			})
			.addCase(fetchAllTransactions.rejected, (state, action) => {
				state.isError = true;
				state.isLoading = false;
				state.transactions = [];
				state.error = action.error?.message;
				state.pages = 0;
			})
			.addCase(createTransaction.pending, (state) => {
				state.isError = false;
				state.isLoading = true;
			})
			.addCase(createTransaction.fulfilled, (state, action) => {
				state.isError = false;
				state.isLoading = false;
				state.transactions.push(action.payload);
			})
			.addCase(createTransaction.rejected, (state, action) => {
				state.isError = true;
				state.isLoading = false;
				state.error = action.error?.message;
			})
			.addCase(changeTransaction.pending, (state) => {
				state.isError = false;
				state.isLoading = true;
			})
			.addCase(changeTransaction.fulfilled, (state, action) => {
				state.isError = false;
				state.isLoading = false;

				const index = state.transactions.findIndex(
					(transaction) => transaction.id === action.payload.id
				);

				state.transactions[index] = action.payload;
			})
			.addCase(changeTransaction.rejected, (state, action) => {
				state.isError = true;
				state.isLoading = false;
				state.error = action.error?.message;
			})
			.addCase(deleteTransaction.pending, (state) => {
				state.isError = false;
				state.isLoading = true;
			})
			.addCase(deleteTransaction.fulfilled, (state, action) => {
				state.isError = false;
				state.isLoading = false;
				state.transactions = state.transactions.filter(
					(transaction) => transaction.id !== action.meta.arg
				);
			})
			.addCase(deleteTransaction.rejected, (state, action) => {
				state.isError = true;
				state.isLoading = false;
				state.error = action.error?.message;
			});
	},
});

export default transactionSlice.reducer;
export const { editActive, editInactive, deleteActive, deleteInactive } =
	transactionSlice.actions;
